import { useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { MessageCirclePlus } from 'lucide-react';
import { Button } from '@jeraisonne/ui';
import { useAuth } from '@/lib/auth';
import { useDiscussions } from '@/lib/discussions/queries';
import { useStudentDocumentDestinations } from '@/lib/documents/destinations';
import { DiscussionsList } from '@/features/discussions/discussions-list';
import { NewDiscussionModal } from '@/features/discussions/new-discussion-modal';

/** « Mes discussions » côté élève — mirroir de `/student/files`. */
export function StudentDiscussionsPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const discussions = useDiscussions();
  const { destinations } = useStudentDocumentDestinations();
  const [showNew, setShowNew] = useState(false);

  const contacts = destinations.filter((d) => d.group === 'contact');

  return (
    <div className="pb-safe mx-auto max-w-2xl px-4 py-6 sm:py-8">
      <header className="mb-5 flex items-center justify-between gap-2">
        <h1 className="font-display text-ink-900 text-2xl font-extrabold tracking-tight">
          Mes discussions
        </h1>
        <Button
          type="button"
          size="sm"
          onClick={() => setShowNew(true)}
          className="min-h-[2.75rem] shrink-0 active:scale-[0.98]"
        >
          <MessageCirclePlus className="mr-1.5 size-4" aria-hidden />
          Nouvelle
        </Button>
      </header>

      {discussions.isLoading && <p className="text-ink-400 text-sm">Chargement…</p>}
      {discussions.isError && (
        <div role="alert" className="text-accent-700 text-sm">
          Impossible de charger tes discussions.
        </div>
      )}
      {!discussions.isLoading && !discussions.isError && user && (
        <DiscussionsList
          discussions={discussions.data ?? []}
          myRole="student"
          onOpen={(id) =>
            void navigate({ to: '/discussions/$discussionId', params: { discussionId: id } })
          }
        />
      )}

      {showNew && user && (
        <NewDiscussionModal
          myRole="student"
          myId={user.id}
          contacts={contacts}
          onClose={() => setShowNew(false)}
          onCreated={(id) => {
            setShowNew(false);
            void navigate({ to: '/discussions/$discussionId', params: { discussionId: id } });
          }}
        />
      )}
    </div>
  );
}
